import { useState } from 'react';
import Modal from './Modal';
import Select from 'react-select';

interface ModalSelectionProps<OptionEnums extends string> {
  actionTitle: string;
  closeModal: () => void;
  selectAction: (selectedOption: OptionEnums) => void;
  title: string;
  message: string;
  options: OptionEnums[];
  optionValueToLabel?: (value: OptionEnums) => string;
  disabledOptions?: OptionEnums[];
  placeholder?: string;
}

const ModalSelection = <OptionEnums extends string>({
  actionTitle,
  closeModal,
  selectAction,
  title,
  message,
  options,
  optionValueToLabel = (value) => value,
  disabledOptions = [],
  placeholder,
}: ModalSelectionProps<OptionEnums>) => {
  const [optionSelected, setOptionSelected] = useState<OptionEnums | null>(
    null,
  );
  return (
    <Modal
      actionTitle={actionTitle}
      closeModal={closeModal}
      actionOnClick={() => {
        if (optionSelected) selectAction(optionSelected);
      }}
      title={title}
      message={message}
      isActionDisabled={optionSelected === null}
    >
      <Select
        className="rounded-lg border-gray-300 gap-2 text-sm leading-6 text-gray-900 placeholder-gray-500 focus-visible:outline-hidden focus-visible:shadow-active focus-visible:ring-offset-2 focus-visible:border-brand-300 disabled:bg-gray-100"
        placeholder={placeholder}
        options={options.map((option) => ({
          value: option,
          label: optionValueToLabel(option),
        }))}
        menuPortalTarget={
          typeof document !== 'undefined' ? document.body : undefined
        }
        menuPosition="fixed"
        styles={{
          indicatorSeparator: (base) => ({ ...base, display: 'none' }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base, { isDisabled }) => ({
            ...base,
            backgroundColor: isDisabled
              ? 'var(--gray-100)'
              : base.backgroundColor,
          }),
          singleValue: (base) => ({
            ...base,
            color: 'var(--gray-900)',
          }),
        }}
        onChange={(option) => {
          setOptionSelected(option?.value ?? null);
        }}
        isOptionDisabled={(option) => disabledOptions.includes(option.value)}
      />
    </Modal>
  );
};

export default ModalSelection;
